import { action, makeObservable, observable, runInAction } from 'mobx';
import { notifyError, notifySuccess } from '../../services/notifications';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../overlays/windowState';
import { TeamModel } from '../jobs';

export class DeleteTeamWindowState
  extends StoreNode {
  readonly nodeType = 'DeleteTeamWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      teams: observable,
      teamId: observable,
      submit: action,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);
  isLoading: boolean = false;
  teams: TeamModel[] | null = [];
  teamId: string | null = null;

  async submit() {
    this.isLoading = true;

    const [, err] = await this.store.apiService.deleteTeam({ id: this.teamId || '' });

    if (err) {
      notifyError(this, 'Could not delete the library.');
      return this.handleSubmitFinally();
    }

    this.emit('team:deleted');
    notifySuccess(this, 'Library deleted.');

    this.handleSubmitFinally();
  }

  handleSubmitFinally() {
    runInAction(() => {
      this.isLoading = false;
      this.close();
    })
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ teamId }: { teamId: string }) {
    this.dispatch('Overlays', 'openWindow', { name: 'DeleteTeamWindow' });

    this.teamId = teamId;
  }

  close() {
    this.teamId = null;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}